export default "__VITE_ASSET__boefC4vT__"